/**
 * @description Listens for apis loaded on "gotstudents" and "gotsummary" events and check for load of all components from dataToLoad, when emits "dataloaded" event
 *
 * @listens "gotstudents" event when studets list was loaded from API
 * @listens "rendercomplete" event when summary was loaded from website backend
 *
 * @emits "dataloaded" event when all data is fully loaded
 */
function DataLoadedCheck() {

	let dataToLoad = [
		"students",
		"summary"
	];

	document.addEventListener( "gotstudents", () => {
		dataToLoad = dataToLoad.filter( component => component != "students" );
		Check( dataToLoad );
	} );

	document.addEventListener( "gotsummary", () => {
		dataToLoad = dataToLoad.filter( component => component != "summary" );
		Check( dataToLoad );
	} );

}

function Check( dataToLoad ) {
	if ( dataToLoad.length == 0 ) {
		const dataloaded = new CustomEvent( "dataloaded" );
		document.dispatchEvent( dataloaded );
	}
}

export { DataLoadedCheck };